import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Popconfirm } from "antd";
import ReactTable from "react-table";
import { Button, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTableFilterSelect from "components/custom/forms/react-table-filter-select";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";
import { closeCustomModal, openCustomModal } from "components/custom/modals";
import {
    getQuestions,
    getQuestionById,
    createQuestion,
    deleteQuestionById
} from "api/menu/master-files/question-library/actions";

import UserTypes from "components/auth/user-types";

const CreateQuestionModal = React.lazy(() =>
    import("components/menu/master-files/question-library/create-question-modal"));

class ListQuestions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeQuestionId: false
        };

        this.reactTable = React.createRef();

        this.getColumns = this.getColumns.bind(this);
        this.handleGetSingle = this.handleGetSingle.bind(this);
        this.handleEditModal = this.handleEditModal.bind(this);
        this.handleDelete = this.handleDelete.bind(this);

        this.props.getQuestions(true);
    }

    getColumns = () => [
        {
            Header: "QID",
            accessor: "id",
            width: 80,
            Cell: ({ original }) => (
                <button
                    className="btn btn-link border-0 m-0 p-0"
                    onClick={() => this.handleGetSingle(original.id)}
                >
                    {original.id}
                </button>
            )
        },
        {
            Header: "Question Text",
            accessor: "text",
            Cell: ({ original }) => (
                typeof original.text === "string"
                    ? original.text.split("\n")
                        .map((item, key) =>
                            <React.Fragment key={key}>
                                {item}<br/>
                            </React.Fragment>)
                    : original.text
            ),
            style: {
                whiteSpace: "unset"
            }
        },
        {
            Header: "Comments",
            accessor: "comments",
            style: {
                whiteSpace: "unset"
            }
        },
        {
            Header: "Active?",
            id: "isInactive",
            accessor: original => (original.isInactive ? "No" : "Yes"),
            Cell: ({ original }) => (original.isInactive ? "No" : "Yes"),
            headerClassName: "text-left",
            Filter: ({
                         filter,
                         onChange
                     }) => (
                <ReactTableFilterSelect
                    currentValue={filter ? filter.value : ""}
                    onChange={value => onChange(value)}
                    style={{
                        width: "100%",
                        height: "100%"
                    }}
                    optionsObject={{
                        "": "Show All",
                        YES: "Yes",
                        NO: "No"
                    }}
                />
            ),
            width: 100,
        },
        {
            Header: "Actions",
            id: "actions",
            className: "text-right",
            show: !this.props.role.includes(UserTypes.accountManager),
            Cell: ({ original }) => (
                <ButtonGroup>
                    <Button size="sm" onClick={() => this.handleEditModal(original.id)}>
                        <FontAwesomeIcon icon="pen" title="Update"/>
                    </Button>
                    <Popconfirm
                        title={`Delete "${original.id}"?`}
                        onConfirm={() => this.handleDelete(original.id)}
                        placement="bottomRight"
                        okText="Yes"
                        cancelText="Cancel"
                    >
                        <Button variant="danger" size="sm">
                            <FontAwesomeIcon icon="times"/>
                        </Button>
                    </Popconfirm>
                </ButtonGroup>
            ),
            filterable: false,
            width: 80
        }
    ];

    handleGetSingle = (id) => {
        this.setState({
            activeQuestionId: id
        }, () => {
            this.props.getQuestionById(id);
        });
    };

    handleEditModal = (questionId) => {
        const modalObj = {
            id: "create-edit-question",
            modalSettings: {
                size: "sm",
            },
            header: `${questionId ? "Update" : "Create"} Question`,
            children: (
                <React.Suspense
                    fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <CreateQuestionModal
                        onSave={() => this.props.closeCustomModal(modalObj)}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        questionId={questionId}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleDelete = (id) => {
        this.props.deleteQuestionById(id);
    };

    render() {
        const {
            loading,
            qlQuestions,
            qlQuestionSingle
        } = this.props;
        const {
            activeQuestionId
        } = this.state;

        return (
            <div className="clearfix">
                <div className="row pt-3 pb-3">
                    <div className="col-12 col-md-9 text-right">
                        {
                            !this.props.role.includes(UserTypes.accountManager) ? <button
                                className="btn btn-success"
                                onClick={() => this.handleEditModal()}
                            >
                                New Question
                            </button> : null
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-9">
                        <ReactTable
                            data={qlQuestions}
                            columns={this.getColumns()}
                            headerClassName="table-header"
                            showPagination={true}
                            defaultPageSize={20}
                            pageSizeOptions={[10, 20, 50, 100]}
                            resizable
                            className="-striped -highlight"
                            loading={loading}
                            filterable={true}
                            defaultFiltered={[{
                                id: "isInactive",
                                value: "YES"
                            }]}
                            defaultSorted={[{
                                id: "id",
                                desc: true
                            }]}
                            defaultFilterMethod={filterCaseInsensitive}
                            style={{
                                height: "calc(100vh - 180px)",
                            }}
                            getTrProps={(state, rowInfo) => {
                                if (rowInfo && rowInfo.original) {
                                    if (rowInfo.original && rowInfo.original.id
                                        === activeQuestionId) {
                                        return {
                                            className: "active"
                                        };
                                    }
                                }
                                return {};
                            }}
                        />
                    </div>
                    <div className="col-12 col-md-3">
                        <ReactTable
                            data={qlQuestionSingle.answers
                                ? qlQuestionSingle.answers.filter(item => item !== null)
                                : []
                            }
                            columns={[
                                {
                                    Header: "Answer",
                                    accessor: "answerText",
                                    style: {
                                        whiteSpace: "unset"
                                    }
                                },
                            ]}
                            headerClassName="table-header"
                            showPagination={false}
                            pageSize={qlQuestionSingle.answers
                                ? Math.max(20, qlQuestionSingle.answers.length)
                                : 20}
                            resizable
                            className="-striped -highlight"
                            loading={loading}
                            filterable={true}
                            defaultFilterMethod={filterCaseInsensitive}
                            style={{
                                height: "calc(100vh - 180px)",
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    role: state.auth.user.role,
    loading: state.questionLibrary.loading,
    qlQuestions: state.questionLibrary.qlQuestions,
    qlQuestionSingle: state.questionLibrary.qlQuestionSingle,
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    getQuestions: bindActionCreators(getQuestions, dispatch),
    getQuestionById: bindActionCreators(getQuestionById, dispatch),
    createQuestion: bindActionCreators(createQuestion, dispatch),
    deleteQuestionById: bindActionCreators(deleteQuestionById, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ListQuestions);
